import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeHighlight from "rehype-highlight";
import rehypeSanitize from "rehype-sanitize";
import { slugify } from "../../utils/slugify";
import CodeBlock from "./CodeBlock";
import ImageModal from "./ImageModal";

function ArticleContent({ content }) {
  const [modalImage, setModalImage] = useState(null);

  const handleImageClick = (src, alt) => {
    setModalImage({ src, alt });
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div className="article-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
        components={{
          // Custom component rendering with IDs for TOC navigation
          h1: ({ node, children, ...props }) => {
            const id = slugify(children);
            return <h1 id={id} className="article-h1" {...props}>{children}</h1>;
          },
          h2: ({ node, children, ...props }) => {
            const id = slugify(children);
            return <h2 id={id} className="article-h2" {...props}>{children}</h2>;
          },
          h3: ({ node, children, ...props }) => {
            const id = slugify(children);
            return <h3 id={id} className="article-h3" {...props}>{children}</h3>;
          },
          p: ({ node, ...props }) => <p className="article-paragraph" {...props} />,
          code: ({ node, inline, className, ...props }) =>
            inline ? (
              <code className="article-inline-code" {...props} />
            ) : (
              <code className="article-code-block" {...props} />
            ),
          pre: ({ node, children, ...props }) => (
            <CodeBlock className={children?.props?.className}>
              {children}
            </CodeBlock>
          ),
          blockquote: ({ node, ...props }) => (
            <blockquote className="article-blockquote" {...props} />
          ),
          a: ({ node, children, ...props }) => (
            <a className="article-link" target="_blank" rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
          img: ({ node, ...props }) => (
            <img
              className="article-image clickable-image"
              {...props}
              alt={props.alt || ''}
              onClick={() => handleImageClick(props.src, props.alt)}
              style={{ cursor: 'pointer' }}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
      
      {modalImage && (
        <ImageModal
          src={modalImage.src}
          alt={modalImage.alt}
          onClose={closeModal}
        />
      )}
    </div>
  );
}

export default ArticleContent;